//Libraries
import { FC, useEffect, useState } from 'react';
import { Button } from '@cb/apricot-react';
import { Grid, CircularProgress } from '@mui/material';

//Typing
import { ISummary } from 'src/types';

//Providers
import { useAuth } from 'src/contexts';

//Processing
import { rejectXpmRequest } from 'src/services/schoolRequest';

//Components
import { FieldRow, FieldLabel, Title, ErrorNotice } from 'src/generic/component';
import { TextArea } from "src/generic/component/form";

interface IRejectProps {
  summary: ISummary;
  reason?: string;
  onComplete: (summary: ISummary) => void;
  onClose: () => void;
}

export const XpmRejectForm: FC<IRejectProps> = ({ summary, reason: initial, onClose, onComplete }) => {
  const { lastName, firstName } = useAuth();

  const [reason, setReason] = useState(initial || '');
  const [loading, setLoading] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    setReason(initial || '');
  }, [initial]);

  const submit = async () => {
    setLoading('Saving');
    try {
      // Post okta migrations, userNames now start with 'Z9Z9P',replacing it with lastName, firstName
      const displayUserName = lastName + ', ' + firstName;
      const update = await rejectXpmRequest(summary, reason, displayUserName);
      summary.updateDate = update.time;
      onComplete(summary);
    } catch (error: any) {
      setError(error.message || error);
    }
    setLoading('');
  };

  return <>
    <Title>Reject Request</Title>
    {error &&
      <ErrorNotice errorMessage={error}></ErrorNotice>
    }
    <FieldRow>
      <FieldLabel>Rejection Reason</FieldLabel>
      <TextArea rows={7}
        validation={undefined}
        validationMsg={''}
        onChange={(e) => {
          setReason(e.target.value);
        }}
        value={reason} />
    </FieldRow>
    <Button disabled={loading ? true : false} style={{ marginRight: '10px' }} onClick={submit}>Submit</Button>
    <Button disabled={loading ? true : false} onClick={onClose}>Close</Button>
    {loading &&
      <div style={{ marginTop: '20px' }}>
        <Grid item xs={12}><CircularProgress /> <div style={{ display: 'inline-block', fontSize: '20px' }}>{loading}</div></Grid>
      </div>
    }
  </>;
};